module.exports = __webpack_public_path__ + "static/media/98.495aaf25.jpg";